import { reactive } from 'vue'

export const store = reactive({
	loggedIn: localStorage.getItem('token')
})
